import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface updateCustomerPaymentLogsPayload {
  withdrawalId: string;
  action: string;
  remarks: string;
}
const updateCustomerPaymentLogs = (client: AxiosInstance) => async (payload: updateCustomerPaymentLogsPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_CUSTOMER_PAYMENT_LIST, payload)).data;
};
export const customerPaymentLogsMutation = {
  updateCustomerPaymentLogs,
};
